import{gql as t}from"@apollo/client";const e=t`
  mutation startInstanceDateUserFlowStep($instanceDate: Date!, $userFlowStepId: Int!) {
    userFlowStepTrack {
      startInstanceDateUserFlowStep(instanceDate: $instanceDate, stepId: $userFlowStepId) {
        id
      }
    }
  }
`;export{e as START_INSTANCE_DATE_USER_FLOW_STEP_MUTATION};
//# sourceMappingURL=useStartInstanceDateUserFlowStep.graphql.js.map
